import React from 'react';
import { ContactSection } from '../components/ContactSection';
import { businessInfo } from '../mockData';

export const ContactPage = () => {
  return (
    <div className="pt-20 bg-gray-50 min-h-screen">
      <ContactSection />
      
      {/* Google Maps Section */}
      <section className="pb-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="p-6 border-b">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Our Service Area</h3>
                <p className="text-gray-600">
                  Based in {businessInfo.address.full}, proudly serving the {businessInfo.serviceArea}
                </p>
              </div>
              <div className="relative w-full h-[500px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26498.842857142857!2d150.8547!3d-33.9167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12f1c8f0f9f9f9%3A0x5017d681632a850!2sCecil%20Hills%20NSW%202171!5e0!3m2!1sen!2sau!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Dezire Metal Roofing Location - Cecil Hills, NSW"
                ></iframe>
              </div>
              <div className="p-6 bg-gray-50">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Location</p>
                    <p className="font-semibold text-gray-900">{businessInfo.address.suburb}, {businessInfo.address.state}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Service Coverage</p>
                    <p className="font-semibold text-gray-900">{businessInfo.serviceArea}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Availability</p>
                    <p className="font-semibold text-primary">{businessInfo.hours}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
